<template> 
  <v-row
    no-gutters
    class="mx-3  "
  >
    <v-col
      cols="9"
    > 
      <v-row
        no-gutters
        class="ml-1 mb-1"
      >
        <v-btn
          class="min-width-force mr-1"
          height="56px"
          width="32%"
          outlined
          @click="addDigit(1)"
        >
          1
        </v-btn>
        <v-btn
          class="mr-1 min-width-force"
          height="56px"
          width="32%"
          outlined
          @click="addDigit(2)"
        >
          2
        </v-btn>
        <v-btn
          class="min-width-force"
          height="56px"
          width="32%"
          outlined
          @click="addDigit(3)"
        >
          3
        </v-btn>
      </v-row>
      <v-row
        no-gutters
        class="ml-1 mb-1 "
      >
        <v-btn
          class="mr-1 min-width-force"
          height="56px"
          width="32%"
          outlined
          @click="addDigit(4)"
        >
          4
        </v-btn><v-btn
          class="mr-1 min-width-force"
          height="56px"
          width="32%"
          outlined
          @click="addDigit(5)"
        >
          5
        </v-btn><v-btn
          class="min-width-force"
          height="56px"
          width="32%"
          outlined
          @click="addDigit(6)"
        >
          6
        </v-btn>
      </v-row>
      <v-row
        no-gutters
        class="ml-1 mb-1 "
      >
        <v-btn
          class="mr-1 min-width-force"
          height="56px"
          width="32%"
          outlined
          @click="addDigit(7)"
        >
          7
        </v-btn><v-btn
          class="mr-1 min-width-force"
          height="56px"
          width="32%"
          outlined
          @click="addDigit(8)"
        >
          8
        </v-btn><v-btn
          class="min-width-force"
          height="56px"
          width="32%"
          outlined
          @click="addDigit(9)"
        >
          9
        </v-btn>
      </v-row>
      <v-row
        no-gutters
        class="mb-2"
        @click="addDigit(0)"
      >
        <v-btn 
          class="ml-1"
          width="calc(96% + 5px)"
          height="59px" 
          outlined
        >
          0
        </v-btn>
      </v-row>
    </v-col>
    <v-col
      cols="3" 
    >
      <v-btn
        depressed
        width="92%"
        height="77px"
        class="mb-1 "
        color="#8b3000"
        dark
        @click="removeDigit ()"
      >
        <v-icon>mdi-keyboard-backspace</v-icon>
      </v-btn>
      <v-btn
        depressed
        width="92%"
        height="77px"
        class="mb-1"
        color="#b8860b"
        dark
        @click="removeLastNumber()"
      >
        <v-icon>mdi-replay</v-icon>
      </v-btn>
      <v-btn
        depressed
        width="92%"
        height="77px"
        class="mb-1"
        outlined
        color="#8b3000"
        @click="clearAll ()"
      >
        {{ $t('button.clear-all') }}
      </v-btn>
    </v-col> 
  </v-row>
</template>
<script>   
const regNumber = eval('/^\\d+$/')
export default { 
    props:{
      methodDigit : {
        type: Function,
        default : function (){
          return []
        }
      },
      isDisable: {
        type: Boolean,
        default: false
      }
    },
    // mounted () {
    //   document.addEventListener("keydown", this.handleKeydown);
    // },

    // beforeDestroy () {
    //   document.removeEventListener("keydown", this.handleKeydown);
    // },
    methods : {
      handleKeydown (e) {
        if(this.isDisable) return
        if(e.keyCode === 8) {
          this.$emit('removeDigit')
          return
        }
        if(e.key
          && e.keyCode !== 8
          && e.keyCode !==46
          && !regNumber.test(e.key)
        ){  
          return
        } 
        const number = parseInt(e.key)
        this.methodDigit (number)
      },
      clearAll () { 
        this.$confirm('',this.$t('confirm.remove-all-stake-list'),'warning').then(()=>{ 
        this.$ga.event('Button', 'Clear', 'NumPad', '')
        this.$emit('clearAll')
        }).catch(()=>{}); 
       },
       addDigit (number) {
         this.$ga.event('Button', 'AddValue', 'NumPad', number)
         this.methodDigit (number)
       },
       removeDigit (){
          this.$ga.event('Button', 'RemoveDigitalNumber', 'NumPad', '')
          this.$emit('removeDigit')
       }, 
       removeLastNumber (){ 
        this.$confirm('',this.$t('confirm.remove-last-stake-number'),'warning').then(()=>{ 
          this.$ga.event('Button', 'RemoveLasttimeNumber', 'NumPad', '')
          this.$emit('removeLastNumber')
        }).catch(()=>{}); 
       },  
    }
    
    
}
</script> 